import { PriorityStringType } from "../views/dataTransformConfig/transformers/base/base-transformer-ui/base-transformer-ui.component";

export class TransformRule {
    name?: string;
    ruleName = '';
    ruleId?: number;
    index: number;
    //transformId?: number;
    //transformConfigId?: number;
    run = true;
    priorityString : PriorityStringType;
}
